'use client';

import { c as _c } from "react/compiler-runtime";
import type { Metadata } from 'next';
import { useTranslations } from 'next-intl';
import { GoToHomepage } from '@/components/go-to-homepage';
import { MainLayout } from '@/components/main-layout';
export const metadata: Metadata = {
  title: '404'
};
function NotFound() {
  const $ = _c(7);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("error.not-found");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h1 className="text-center text-6xl font-semibold">{t0}</h1>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <GoToHomepage />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <MainLayout><div className="mt-52 mb-40 flex flex-col items-center justify-center gap-12">{t1}{t2}</div></MainLayout>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export default NotFound;